

export const FETCH_RATEADMIN_NETWORKS_LIST = {
    START: 'FETCH_RATEADMIN_NETWORKS_LIST_START',
    SUCCESS: 'FETCH_RATEADMIN_NETWORKS_LIST_SUCCESS',
    ERROR: 'FETCH_RATEADMIN_NETWORKS_LIST_ERROR',
  };
  export const TOAST = {
    RESET: 'RESET_TOAST',
  };
  export const FETCH_RATEADMIN_NETWORKS_INIT="FETCH_RATEADMIN_NETWORKS_INIT"
  export const SET_DELETE_CONFIRMATION_POPUP_VISIBILITY =
  'SET_DELETE_CONFIRMATION_POPUP_VISIBILITY';


  
export const INIT_CREATE_RATEADMIN_NETWORKS_SCREEN =
'INIT_CREATE_RATEADMIN_NETWORKS_SCREEN';

export const CREATE_RATEADMIN_NETWORKS = {
START: 'CREATE_RATEADMIN_NETWORKS_START',
SUCCESS: 'CREATE_RATEADMIN_NETWORKS_SUCCESS',
ERROR: 'CREATE_RATEADMIN_NETWORKS_ERROR',
};

export const EDIT_RATEADMIN_NETWORKS = {
START: 'EDIT_RATEADMIN_NETWORKS_START',
SUCCESS: 'EDIT_RATEADMIN_NETWORKS_SUCCESS',
ERROR: 'EDIT_RATEADMIN_NETWORKS_ERROR',
};

export const FETCH_RATEADMIN_NETWORKS_DETAIL = {
  START: 'FETCH_RATEADMIN_NETWORKS_DETAIL_START',
  SUCCESS: 'FETCH_RATEADMIN_NETWORKS_DETAIL_SUCCESS',
  ERROR: 'FETCH_RATEADMIN_NETWORKS_DETAIL_ERROR',
};
export const EXPORT_RATEADMIN_NETWORKS = {
  START: 'EXPORT_RATEADMIN_NETWORKS_START',
  SUCCESS: 'EXPORT_RATEADMIN_NETWORKS_SUCCESS',
  ERROR: 'EXPORT_RATEADMIN_NETWORKS_ERROR',
};
export const RATEADMIN_NETWORKSDD = {
  START: 'RATEADMIN_NETWORKSDD_START',
  SUCCESS: 'RATEADMIN_NETWORKSDD_SUCCESS',
  ERROR: 'RATEADMIN_NETWORKSDD_ERROR',
};
export const RATEADMIN_NETWORKS_SAVE_TABLE_STATE = 'RATEADMIN_NETWORKS_SAVE_TABLE_STATE';

export const SWITCH_DEFAULT_NETWORK = {
  START: 'SWITCH_DEFAULT_NETWORK_START',
  SUCCESS: 'SWITCH_DEFAULT_NETWORK_SUCCESS',
  ERROR: 'SWITCH_DEFAULT_NETWORK_ERROR',
};

export const FETCH_NETWORK_AUDIT_TRAIL = {
  START: "FETCH_NETWORK_AUDIT_TRAIL_START",
  SUCCESS: "FETCH_NETWORK_AUDIT_TRAIL_SUCCESS",
  ERROR: "FETCH_NETWORK_AUDIT_TRAIL_ERROR",
};

export const FETCH_NETWORK_CREDENTIALS = {
  START: "FETCH_NETWORK_CREDENTIALS_START",
  SUCCESS: "FETCH_NETWORK_CREDENTIALS_SUCCESS",
  ERROR: "FETCH_NETWORK_CREDENTIALS_ERROR",
};

export const UPDATE_NETWORK_CREDENTIALS = {
  START: "UPDATE_NETWORK_CREDENTIALS_START",
  SUCCESS: "UPDATE_NETWORK_CREDENTIALS_SUCCESS",
  ERROR: "UPDATE_NETWORK_CREDENTIALS_ERROR",
};